import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import overrideStyle from 'lib/overrideStyle';

const Wrapper = overrideStyle('div')`
    padding: 0 15px;
    padding-top: 5px;
`;

export default function OfficeHourDisplay(props) {
  const newNode = document.createElement('div');
  newNode.innerHTML = props.message;

  return (
    <Wrapper
      ref={nodeElement => {
        nodeElement && nodeElement.appendChild(newNode);
      }}
    />
  );
}

OfficeHourDisplay.propTypes = {
  message: PropTypes.string.isRequired,
};
